module.exports = __webpack_public_path__ + "img/c74c548.jpg";